import { DFormHelpers, IDFormControl } from "./../../d-form/d-form.helpers";
import { Helpers } from "projects/training-calendar/src/app/helpers";
import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from "@angular/core";
import { getAddCourse } from "./add-course-to-sector.element.component";
import { SectorsService } from "projects/services/src/app/API/sectors.service";
import { TrainingPartnerService } from "projects/services/src/app/API/training-partner.service";
import { DropdownService } from "projects/services/src/app/API/dropdown.service";
import { STRING, S3URLS, PROJECT_TYPE } from "../../types";
import { COURSE_JOB_ROLE_MAPPING_TYPE } from "projects/training-partner/src/app/training-partner/constants/string.constant";
import { STATE } from "projects/training-partner/src/app/training-partner/constants";
import { SharedService } from "projects/services/src/app/shared/shared.service";
import { Validators } from "@angular/forms";
import { map } from "rxjs";
import { FileService } from "projects/services/src/app/API/document/file.service";
declare const toastr: any;

@Component({
	selector: "app-add-course-to-sector-g",
	templateUrl: "./add-course-to-sector.component.html",
	styleUrls: ["./add-course-to-sector.component.css"],
})
export class AddCourseToSectorComponent implements OnInit {

	@ViewChild('thumbnailLogoChild') thumbnailLogoChild: ElementRef;

	@Input() defaultValues: any = {};
	@Input() selectedSchemeId: string;
	@Input() state = STATE.FILLING;
	jobroleISBorrowed: any;
	courseForm: any;
	project: any = {};
	formLoaded: boolean;
	sectors: any = [];
	numberOfDays: any = {};
	courseFormControl: IDFormControl;
	selectedSector: any;
	minimumEducationRequired: any = [];
	nsqfLevelRequired: any = [];
	isQpNosJobRoleType = false;
	default = {
		minimumEducationRequiredOptions: [],
	};
	data: any = {
		sectorOptions: [],
		jobRolesOptions: [],
		repositryOptions: [],
		nsqfLevelsOptions: [],
		minimumEducationRequiredOptions: [],
	};
	@Output() submit = new EventEmitter();
	@Output() cancel = new EventEmitter();

	selectedJobRoleMappingType: any;
	uploadedThumbnailLogo: any;

	thumbnailLogoProperties = {
		naturalHeight: 125,
		naturalWidth: 236
	}

	uploadedThumbnailLogoProperties = {
		naturalHeight: 0,
		naturalWidth: 0
	}

	constructor(
		private sectorService: SectorsService,
		private trainingPartnerService: TrainingPartnerService,
		private dropdownService: DropdownService,
		private sharedService: SharedService,
		private fileService: FileService
	) {
		this.getNsqfLevel();
	}

	ngOnInit() {
		this.defaultValues = this.defaultValues || {};
		this.numberOfDays.toString = () => {
			const course = this.courseFormControl.value();
			if (course) {
				const courseDurationInHours = course.courseDurationInHours;
				const hoursPerDay = course.hoursPerDay;
				if (hoursPerDay && courseDurationInHours) {
					return `${Math.ceil(
						courseDurationInHours / hoursPerDay
					)} working days to Complete`;
				}
				return "";
			}
		};
		this.trainingPartnerService
			.getSelectedScheme(this.selectedSchemeId)
			.subscribe((data) => {
				console.log(data);
				this.project = data;
			});
		this.getMinimumEducationRequired().subscribe(
			(minimumEducationRequiredOptions) => {
				Helpers.copyArray(
					this.data.minimumEducationRequiredOptions,
					minimumEducationRequiredOptions
				);
				Helpers.copyArray(
					this.default.minimumEducationRequiredOptions,
					this.minimumEducationRequired
				);
			}
		);
		this.trainingPartnerService
			.getSelectedSchemeSectors(this.selectedSchemeId, undefined, {
				onlyApproved: true,
			})
			.subscribe((res) => {
				let sectors = [];
				if (res && res.data && res.data.length) {
					sectors = res.data.map((sector) => {
						this.sectors.push({
							name: sector.name,
							value: sector.sectorReferenceId,
						});
						return {
							name: sector.name,
							value: sector.name,
						};
					});
				}
				this.data.sectorOptions = sectors;
				// this.sectorService.getJobRolesForSelect()
				const button: any = {};
				switch (this.state) {
					case STATE.FILLING: {
						button.submitText = "Submit";
						button.cancelText = "Cancel";
						break;
					}
					case STATE.EDITING: {
						button.submitText = "Resubmit";
						button.cancelText = "Cancel";
						break;
					}
					case STATE.VIEWING: {
						(button.submit = ""), (button.cancelText = "Cancel");
						break;
					}
					case STATE.UPDATE: {
						(button.submitText = "Update & Submit"),
							(button.cancelText = "Cancel");
						break;
					}
				}
				if (this.defaultValues) {
					this.defaultValues.minimumEducationRequired =
						this.defaultValues.minimumEducationRequiredValue;
					this.defaultValues.couseValidity = this.defaultValues
						.validity
						? this.defaultValues.validity.toDate
						: null;
				}

				this.courseForm = getAddCourse(
					Object.assign(
						{
							sectorsOptions: this.data.sectorOptions,
							gradingPreferencesOptions: ["A", "B", "C"],
							jobRoleMappingTypeOptions: ["A", "B", "C"],
							jobRolesOptions: this.data.jobRolesOptions,
							repositryOptions: this.data.repositryOptions,
							minimumEducationRequiredOptions:
								this.data.minimumEducationRequiredOptions,
							minimumEducationRequired:
								this.defaultValues.minimumEducationRequired,
							nsqfLevel: this.defaultValues.nsqfLevel,
							nsqfLevelsOptions: this.data.nsqfLevelsOptions,
							minimumEducationRequiredValue:
								this.defaultValues.minimumEducationRequired,
							stage: this.state,
							daysInfo: this.numberOfDays,
						},
						button
					),
					{
						sectorChange: this.onSectorChange.bind(this),
						jobRoleMappingChange:
							this.onJobRoleMappingTypeChange.bind(this),
						jobRoleChange: this.onJobRoleChange.bind(this),
						thumbnailImageChange: this.onThumbnailImageChange.bind(this),
					}
				);
				if (this.defaultValues.status === "Not Approved") {
					this.defaultValues.couseValidity = null;
					const form = DFormHelpers.forms(this.courseForm);
					form.disableFields(["couseValidity"], false);
				}
				if (this.state === "update") {
					this.defaultValues.couseValidity = null;
					// const form = DFormHelpers.forms(this.courseForm);
					// const readableFields = [
					// 	"sectorName",
					// 	"jobRoleMappingType",
					// 	"jobRoleName",
					// ];
					// form.makeFieldsReadOnly(readableFields, true);
					// this.checkFieldsValues();
					this.defaultValues.stampPaperWithSelfDeclaration = [];
					// form.disableFields(['couseValidity'], false);
					// form.disableFields(['jobRoleName'], true);
					// form.makeFieldsReadOnly(['jobRoleMappingType'], true);
					// form.makeFieldsReadOnly(['expository'], true);
					// form.makeFieldsReadOnly([''], true);
					// form.makeFieldsReadOnly(['nsqfLevel'], true);
					// form.disableFields(['description'], true);
				}
				this.formLoaded = true;
			});
	}

	checkFieldsValues() {
		const form = DFormHelpers.forms(this.courseForm);
		const readableFields = [
			"sectorName",
			"jobRoleMappingType",
			"jobRoleName",
			"nsqfLevel",
			"description"
		];
		form.makeFieldsReadOnly(readableFields, true);
		if (
			this.defaultValues.course !== "" &&
			this.defaultValues.course !== null &&
			this.defaultValues.course !== undefined
		) {
			form.makeFieldsReadOnly(["course"], true);
		} else {
			form.makeFieldsReadOnly(["course"], false);
		}
		if (
			this.defaultValues.nsqfLevel !== "" &&
			this.defaultValues.nsqfLevel !== null &&
			this.defaultValues.nsqfLevel !== undefined
		) {
			form.makeFieldsReadOnly(["nsqfLevel"], true);
		} else {
			form.makeFieldsReadOnly(["nsqfLevel"], false);
		}
		if (
			this.defaultValues.description !== "" &&
			this.defaultValues.description !== null &&
			this.defaultValues.description !== undefined
		) {
			form.makeFieldsReadOnly(["description"], true);
		} else {
			form.makeFieldsReadOnly(["description"], false);
		}
		if (
			this.defaultValues.issuedCertificateName !== "" &&
			this.defaultValues.issuedCertificateName !== null &&
			this.defaultValues.issuedCertificateName !== undefined
		) {
			form.makeFieldsReadOnly(["issuedCertificateName"], true);
		} else {
			form.makeFieldsReadOnly(["issuedCertificateName"], false);
		}
		if (
			this.defaultValues.minimumAge !== "" &&
			this.defaultValues.minimumAge !== null &&
			this.defaultValues.minimumAge !== undefined
		) {
			form.makeFieldsReadOnly(["minimumAge"], true);
		} else {
			form.makeFieldsReadOnly(["minimumAge"], false);
		}
		if (
			this.defaultValues.minimumEducationRequired !== "" &&
			this.defaultValues.minimumEducationRequired !== null &&
			this.defaultValues.minimumEducationRequired !== undefined
		) {
			form.makeFieldsReadOnly(["minimumEducationRequired"], true);
		} else {
			form.makeFieldsReadOnly(["minimumEducationRequired"], false);
		}
		if (
			this.defaultValues.courseDurationInHours !== "" &&
			this.defaultValues.courseDurationInHours !== null &&
			this.defaultValues.courseDurationInHours !== undefined
		) {
			form.makeFieldsReadOnly(["courseDurationInHours"], true);
		} else {
			form.makeFieldsReadOnly(["courseDurationInHours"], false);
		}
		if (
			this.defaultValues.hoursPerDay !== "" &&
			this.defaultValues.hoursPerDay !== null &&
			this.defaultValues.hoursPerDay !== undefined
		) {
			form.makeFieldsReadOnly(["hoursPerDay"], true);
		} else {
			form.makeFieldsReadOnly(["hoursPerDay"], false);
		}
		if (
			this.defaultValues.courseFee !== "" &&
			this.defaultValues.courseFee !== null &&
			this.defaultValues.courseFee !== undefined
		) {
			form.makeFieldsReadOnly(["courseFee"], true);
		} else {
			form.makeFieldsReadOnly(["courseFee"], false);
		}
		if (
			this.defaultValues.gradingPreferences !== "" &&
			this.defaultValues.gradingPreferences !== null &&
			this.defaultValues.gradingPreferences !== undefined
		) {
			form.makeFieldsReadOnly(["gradingPreferences"], true);
		} else {
			form.makeFieldsReadOnly(["gradingPreferences"], false);
		}
		if (
			this.defaultValues.couseValidity !== "" &&
			this.defaultValues.couseValidity !== null &&
			this.defaultValues.couseValidity !== undefined
		) {
			form.makeFieldsReadOnly(["couseValidity"], true);
		} else {
			form.makeFieldsReadOnly(["couseValidity"], false);
		}
	}

	get calculatedNumberOfDays() {
		return {
			toString: () => {
				const course = this.courseFormControl.value();
				const courseDurationInHours = course.courseDurationInHours;
				const hoursPerDay = course.hoursPerDay;
				if (hoursPerDay && courseDurationInHours) {
					return courseDurationInHours / hoursPerDay;
				}
				return "not found";
			},
		};
	}

	onJobRoleChange(jobRoleName) {
		let selectedJobRole;
		if (this.state === STATE.FILLING) {
			if (jobRoleName.expoCode) {
				selectedJobRole = this.data.jobRolesOptions.find(
					(role) => (role.data.jobRole === jobRoleName.jobRole &&
						role.data.qpCode === jobRoleName.qpCode &&
						role.data.version === jobRoleName.version &&
						role.data.expository[0].expoCode === jobRoleName.expoCode)
				);
			} else {
				selectedJobRole = this.data.jobRolesOptions.find(
					(role) => (role.data.jobRole === jobRoleName.jobRole &&
						role.data.qpCode === jobRoleName.qpCode &&
						role.data.version === jobRoleName.version)
				);
			}
		} else {
			if (this.defaultValues && this.defaultValues.expository && this.defaultValues.expository[0] && this.defaultValues.expository[0].expoCode) {
				selectedJobRole = this.data.jobRolesOptions.find(
					(role) => (role.data.jobRole === this.defaultValues.jobRoleName &&
						role.data.qpCode === this.defaultValues.qpCode &&
						role.data.version === this.defaultValues.qpVersion &&
						role.data.expository[0].expoCode === this.defaultValues.expository[0].expoCode)
				);
			} else {
				selectedJobRole = this.data.jobRolesOptions.find(
					(role) => (role.data.jobRole === this.defaultValues.jobRoleName &&
						role.data.qpCode === this.defaultValues.qpCode &&
						role.data.version === this.defaultValues.qpVersion)
				);
			}

		}
		const form = DFormHelpers.forms(this.courseForm);
		// const elementRef = form.getFormRef("jobRoleName");
		// elementRef.patchValue(jobRoleName);
		// elementRef.updateValueAndValidity();
		// selectedJobRole.value = selectedJobRole.name;
		// if (jobRoleName === 'Qp-Nos Not Matching') {
		// 	form.disableFields(['nsqfLevel'], false);
		// 	Helpers.copyArray(this.data.minimumEducationRequiredOptions, this.minimumEducationRequired);
		// } else {
		// 	Helpers.copyArray(this.data.minimumEducationRequiredOptions, []);
		// }
		this.jobroleISBorrowed = selectedJobRole;
		let educationQualification =
			Helpers.getValueFromObject(selectedJobRole, "data.minEduQual") ||
			[];
		const jobRoleDesc = Helpers.getValueFromObject(
			selectedJobRole,
			"data.jobRoleDesc"
		);
		const repositryOptions =
			Helpers.getValueFromObject(selectedJobRole, "data.expository") ||
			[];

		// let educationQualification = Helpers.getValueFromObject(selectedJobRole, 'data.minEduQual') || [];
		let isBorrowedRole = Helpers.getValueFromObject(selectedJobRole, 'data.isBorrowed') || false;
		// const repositryOptions = Helpers.getValueFromObject(selectedJobRole, 'data.expository') || [];
		if (isBorrowedRole === true && this.selectedSector.name === 'PwD' && repositryOptions && repositryOptions[0].minEducation) {
			educationQualification = Helpers.getValueFromObject(selectedJobRole, 'data.expository[0].minEducation') || repositryOptions[0].minEducation;
		}
		if (repositryOptions && repositryOptions.length !== 0) {
			if (
				this.courseForm &&
				this.courseForm.forms &&
				this.courseForm.forms[0] &&
				this.courseForm.forms[0].formRef
			) {
				this.sharedService.setValidators(
					this.courseForm.forms[0].formRef,
					"expository",
					[Validators.required]
				);
				this.courseFormControl.resetFields(["expository"]);
			}
			const mappedRepositryOptions = repositryOptions.map((reps) => {
				return {
					name: `${reps.expoName} (Code: ${reps.expoCode}, Version: ${reps.version})`,
					value: {
						expoName: reps.expoName,
						expoCode: reps.expoCode,
						version: reps.version,
					},
				};
			});
			Helpers.copyArray(
				this.data.repositryOptions,
				mappedRepositryOptions
			);
		} else {
			Helpers.copyArray(this.data.repositryOptions, []);
			if (
				this.courseForm &&
				this.courseForm.forms &&
				this.courseForm.forms[0] &&
				this.courseForm.forms[0].formRef
			) {
				this.sharedService.clearValidators(
					this.courseForm.forms[0].formRef,
					"expository"
				);
				this.courseFormControl.hideFields(["expository"]);
			}
		}
		const mappedEducationQualification = educationQualification.map(
			(qual) => {
				return {
					name: qual.minEduQualDesc,
					value: qual.minEduQualID,
				};
			}
		);
		let minimumEducationRequired;
		if (mappedEducationQualification.length === 1) {
			minimumEducationRequired = mappedEducationQualification[0].value;
		}
		const minJobEntryAge = Helpers.getValueFromObject(
			selectedJobRole,
			"data.minJobEntryAge.minJobEntryAge"
		);

		if (selectedJobRole && selectedJobRole.name !== "Qp-Nos Not Matching") {
			Helpers.copyArray(
				this.data.minimumEducationRequiredOptions,
				mappedEducationQualification
			);
		} else {
			Helpers.copyArray(
				this.data.minimumEducationRequiredOptions,
				this.minimumEducationRequired
			);
		}


		if (minJobEntryAge) {
			let courseName
			if (this.state === STATE.FILLING) {
				courseName = jobRoleName.jobRole;
			} else {
				courseName = jobRoleName;
			}
			if (this.defaultValues.course) {
				courseName = this.defaultValues.course;
				delete this.defaultValues.courseName;
			}
			const patchObj: any = {
				minimumAge: Number(minJobEntryAge) || STRING.EMPTY,
				description: jobRoleDesc,
				jobRoleName: selectedJobRole.value,
				course: courseName,
				minimumEducationRequired: minimumEducationRequired
					? minimumEducationRequired
					: "",
			};
			if (this.defaultValues.minimumEducationRequiredValue) {
				patchObj.minimumEducationRequired =
					this.defaultValues.minimumEducationRequiredValue;
				delete this.defaultValues.minimumEducationRequiredValue;
			}
			form.patchValues(patchObj);
			if (this.state === "update") {
				this.checkFieldsValues();
			}
		} else {
			if (this.state === "update") {
				this.checkFieldsValues();
			}
		}
		if (selectedJobRole && selectedJobRole.name !== "Qp-Nos Not Matching") {
			if (this.selectedJobRoleMappingType === COURSE_JOB_ROLE_MAPPING_TYPE.OTHERS) {
				// const elementRef = form.getFormRef("nsqfLevel");
				const elementsToBeDisable = ['nsqfLevel'];
				const form = DFormHelpers.forms(this.courseForm);
				form.makeFieldsReadOnly(elementsToBeDisable, false);
				const elementRef = form.getFormRef("nsqfLevel");
				elementRef.reset();
				elementRef.setValidators([]);
				elementRef.updateValueAndValidity();
			} else {
				this.getNsqfLevel();
				const nsqfLevel: any = Number(selectedJobRole.data.nsqfLevel);
				const elementRef = form.getFormRef("nsqfLevel");
				elementRef.setValidators([Validators.required]);
				elementRef.setValue(nsqfLevel);
				elementRef.updateValueAndValidity();
			}
		} else {
			const elementRef = form.getFormRef("nsqfLevel");
			if (this.state !== "update") {
				elementRef.reset();
				// elementRef.enable();
				form.makeFieldsReadOnly(["nsqfLevel"], false);
				elementRef.updateValueAndValidity();
			}
			// form.disableFields(['nsqfLevel'], false);
		}
	}

	onJobRoleMappingTypeChange(data) {
		// let selectedJobRole;
		// if (this.defaultValues.status === 'Not Approved') {
		// 	if (this.defaultValues && this.defaultValues.expository && this.defaultValues.expository[0] && this.defaultValues.expository[0].expoCode) {
		// 		selectedJobRole = this.data.jobRolesOptions.find(
		// 			(role) => (role.data.jobRole === this.defaultValues.jobRoleName &&
		// 				role.data.qpCode === this.defaultValues.qpCode &&
		// 				role.data.version === this.defaultValues.qpVersion &&
		// 				role.data.expository[0].expoCode === this.defaultValues.expository[0].expoCode)
		// 		);
		// 	} else {
		// 		selectedJobRole = this.data.jobRolesOptions.find(
		// 			(role) => (role.data.jobRole === this.defaultValues.jobRoleName &&
		// 				role.data.qpCode === this.defaultValues.qpCode &&
		// 				role.data.version === this.defaultValues.qpVersion)
		// 		);
		// 	}
		// }
		this.selectedJobRoleMappingType = data;
		const typeOfProject = Helpers.getValueFromObject(
			this.project,
			"schemes.project.typeOfPia"
		);
		const elementsToBeDisable = ["jobRoleName"];
		// const elementsToBeDisable = ['jobRoleName', 'nsqfLevel', 'expository'];
		const readOnlyFields = [
			"minimumAge",
			"description",
			"course",
			"nsqfLevel",
		];
		const form = DFormHelpers.forms(this.courseForm);
		// const patchObj: any = {
		// 	jobRoleName: ""
		// }
		// form.patchValues(patchObj);
		let courseDocument;
		if (typeOfProject === PROJECT_TYPE.FUNDED) {
			courseDocument = S3URLS.COURSE.FUNDED.QPNOS_AVAIL;
		} else {
			courseDocument = S3URLS.COURSE.NON_FUNDED.QPNOS_AVAIL;
		}
		this.isQpNosJobRoleType = true;
		// const form = DFormHelpers.forms(this.courseForm);

		const sector = form.getFormElement("sectorName");
		if (sector) {
			if (data === "Non-QP/NOS Alligned") {
				this.onSectorChange(sector.value, data);
			} else {
				this.onSectorChange(sector.value);
			}
		}
		if (this.state !== "update") {
			form.makeFieldsReadOnly(readOnlyFields);
			form.disableFields(elementsToBeDisable, false);
		} else {
			form.disableFields(elementsToBeDisable, true);
			form.disableFields(["description"], true);
		}

		if (data === COURSE_JOB_ROLE_MAPPING_TYPE.OTHERS) {
			if (typeOfProject === PROJECT_TYPE.FUNDED) {
				courseDocument = S3URLS.COURSE.FUNDED.QPNOS_UNAVAIL;
			} else {
				courseDocument = S3URLS.COURSE.NON_FUNDED.QPNOS_UNAVAIL;
			}
			this.isQpNosJobRoleType = false;
			Helpers.copyArray(
				this.data.minimumEducationRequiredOptions,
				this.minimumEducationRequired
			);
			if (this.state !== "update") {
				form.makeFieldsReadOnly(readOnlyFields, false);
				form.disableFields(elementsToBeDisable, false);
			} else {
				form.disableFields(elementsToBeDisable, true);
				form.disableFields(["description"], true);
			}
		} else {
			if (typeOfProject === PROJECT_TYPE.FUNDED) {
				courseDocument = S3URLS.COURSE.FUNDED.QPNOS_AVAIL;
			} else {
				courseDocument = S3URLS.COURSE.NON_FUNDED.QPNOS_AVAIL;
			}
			this.isQpNosJobRoleType = true;
			const sectors = form.getFormElement("sectorName");
			if (sectors) {
				this.onSectorChange(sectors.value);
			}
			if (this.state !== "update") {
				form.makeFieldsReadOnly(readOnlyFields);
				form.disableFields(elementsToBeDisable, false);
			} else {
				form.disableFields(elementsToBeDisable, true);
				form.disableFields(["description"], true);
			}
		}
		form.getFormElement(
			"stampPaperWithSelfDeclaration"
		).documentTemplateUrl = courseDocument;
	}

	getMinimumEducationRequired() {
		return this.dropdownService
			.getEducationalQualifications()
			.pipe(map((qualifications) => {
				qualifications = qualifications.map((qual) => {
					this.minimumEducationRequired.push({
						name: qual.eduQualDesc,
						value: qual.eduQualID,
					});
					return {
						name: qual.eduQualDesc,
						value: qual.eduQualDesc,
					};
				});
				return qualifications;
			}));
	}

	getNsqfLevel() {
		this.sectorService
			.getNsqfLevelForSelect()
			.subscribe((nsqfLevelsOptions) => {
				Helpers.copyArray(
					this.data.nsqfLevelsOptions,
					nsqfLevelsOptions
				);
			});
	}

	onSectorChange(sectorName, qpType?) {
		Helpers.copyArray(this.data.repositryOptions, []);
		Helpers.copyArray(this.data.jobRolesOptions, []);
		this.selectedSector = this.sectors.find((s) => s.name === sectorName);
		if (this.selectedSector) {
			let expoCode = "";
			let expoVersion = "";
			if (this.defaultValues && this.defaultValues.expository && this.defaultValues.expository[0]) {
				expoCode = this.defaultValues.expository[0].expoCode ? this.defaultValues.expository[0].expoCode : "";
				expoVersion = this.defaultValues.expository[0].version ? this.defaultValues.expository[0].version : "";
			}
			let qpCode = "";
			let qpVersion = "";
			if (this.state !== STATE.FILLING) {
				qpCode = this.defaultValues.qpCode ? this.defaultValues.qpCode : "";
				qpVersion = this.defaultValues.qpVersion ? this.defaultValues.qpVersion : "";
			}
			const sectorId = this.selectedSector.value;
			this.getJobRoles(sectorId, qpType, expoCode, expoVersion, qpCode, qpVersion).subscribe((jobRoles) => {
				Helpers.copyArray(this.data.jobRolesOptions, jobRoles);
			});
		}
		this.sectorService
			.getNsqfLevelForSelect()
			.subscribe((nsqfLevelsOptions) => {
				Helpers.copyArray(
					this.data.nsqfLevelsOptions,
					nsqfLevelsOptions
				);
				Helpers.copyArray(this.nsqfLevelRequired, nsqfLevelsOptions);
			});
	}


	getJobRoles(sectorId, qpType?, expoCode?, expoVersion?, qpCode?, qpVersion?) {
		if (this.state === "update") {
			return this.sectorService.getJobRolesForSelect(
				sectorId,
				"ignoreStatus",
				qpType,
				expoCode,
				expoVersion,
				qpCode,
				qpVersion
			).pipe(map(jobRoles => {
				jobRoles.map(jobRole => {
					console.log(jobRole);
					jobRole.value = `${jobRole.name}${jobRole.data.expository && jobRole.data.expository.length > 0 ? ',' + jobRole.data.expository[0].expoCode : ''}`;
				})
				console.log(jobRoles);
				return jobRoles;
			}));
		} else {
			return this.sectorService.getJobRolesForCourse(
				sectorId,
				"",
				qpType
			)
		}
	}

	onSubmit(data) {
		console.log("dataaaaa", data, this.minimumEducationRequired);
		const jobRole = this.minimumEducationRequired.find(
			(e) =>
				e.value === data.minimumEducationRequiredValue ||
				e.name === data.minimumEducationRequiredValue ||
				e.value === data.minimumEducationRequired ||
				e.name === data.minimumEducationRequired
			// e => e.name === data.minimumEducationRequired
		);
		const jobRoleData = data.jobRoleName ? data.jobRoleName : data;
		if (this.isQpNosJobRoleType) {
			const jobRoleName = jobRoleData.jobRole
			data.jobRoleName = jobRoleName;

			let filteredJobRoleOptions;

			if (this.state === STATE.FILLING) {
				filteredJobRoleOptions = this.data.jobRolesOptions.filter(
					(role) => {
						return (role.data.jobRole === jobRoleData.jobRole &&
							role.data.qpCode === jobRoleData.qpCode &&
							role.data.version === jobRoleData.version);
					}
				);
			} else {
				filteredJobRoleOptions = this.data.jobRolesOptions.filter(
					(role) => {
						return (role.data.jobRole === this.defaultValues.jobRoleName &&
							role.data.qpCode === this.defaultValues.qpCode &&
							role.data.version === this.defaultValues.qpVersion);
					}
				);
			}
			if (filteredJobRoleOptions instanceof Array) {
				filteredJobRoleOptions =
					filteredJobRoleOptions[0] && filteredJobRoleOptions[0].data;
			}
			const selectedSector = filteredJobRoleOptions.sectors;
			const qpInfo = selectedSector;
			qpInfo.qpCode = filteredJobRoleOptions.qpCode;
			qpInfo.qpVersion = filteredJobRoleOptions.version;
			delete qpInfo.sectorName;
			Object.assign(data, qpInfo);
		} else {
			const jobRoleName = jobRoleData.jobRole
			data.jobRoleName = jobRoleName;
		}
		if (
			this.jobroleISBorrowed &&
			this.jobroleISBorrowed.data &&
			this.jobroleISBorrowed.data.isBorrowed
		) {
			if (
				this.jobroleISBorrowed.data.propAssmtCertPlan &&
				this.jobroleISBorrowed.data.propAssmtCertPlan
					.assmtCertCndctdBy &&
				this.jobroleISBorrowed.data.propAssmtCertPlan.assmtCertCndctdBy
					.sector
			) {
				data["sectorName"] =
					this.jobroleISBorrowed.data.propAssmtCertPlan.assmtCertCndctdBy.sector.name;
				data["sectorId"] =
					this.jobroleISBorrowed.data.propAssmtCertPlan.assmtCertCndctdBy.sector.id;
			}
		} else {
			const sector = this.sectors.find((s) => s.name === data.sectorName);
			data.sectorId = sector.value;
		}
		console.log("mapped data", jobRole, data);
		data.minimumEducationRequiredValue = jobRole
			? jobRole.name
			: "Not Applicable";
		data.minimumEducationRequiredId = jobRole ? jobRole.value : "38"; //ID for Not Applicable
		data.validity = {
			toDate: data.couseValidity,
		};
		Helpers.mapObject(data, {
			minimumEducationRequired: [
				"minimumEducationRequiredId?id",
				"minimumEducationRequiredValue?value",
			],
		});
		this.submit.emit(data);
	}

	onThumbnailImageChange(event) {
		this.fileService.getImageURL(event).subscribe((sectorRes: any) => {
			this.uploadedThumbnailLogo = sectorRes
			const img: any = new Image()
			img.src = sectorRes
			img.onload = () => {
				this.uploadedThumbnailLogoProperties.naturalHeight = this.thumbnailLogoChild.nativeElement.naturalHeight
				this.uploadedThumbnailLogoProperties.naturalWidth = this.thumbnailLogoChild.nativeElement.naturalWidth
				this.previewCertificate();
			}
		})
	}

	previewCertificate() {
		const form = DFormHelpers.forms(this.courseForm);
		const elementRef = form.getFormRef("thumbnail");
		if (this.thumbnailLogoProperties.naturalHeight !== 0 && this.thumbnailLogoProperties.naturalWidth !== 0) {
			if (this.thumbnailLogoProperties.naturalHeight !== this.uploadedThumbnailLogoProperties.naturalHeight &&
				this.thumbnailLogoProperties.naturalWidth !== this.uploadedThumbnailLogoProperties.naturalWidth) {
				toastr.error('Height and Width does not match, Recommended image size (236*125)');
				elementRef.reset();
				elementRef.updateValueAndValidity();
			}
			return
		}
		if (this.thumbnailLogoProperties.naturalHeight !== this.uploadedThumbnailLogoProperties.naturalHeight) {
			toastr.error('Height does not match, Recommended image size (236*125)');
			elementRef.reset();
			elementRef.updateValueAndValidity();
			return
		}
		if (this.thumbnailLogoProperties.naturalWidth !== this.uploadedThumbnailLogoProperties.naturalWidth) {
			toastr.error('Width does not match, Recommended image size (236*125)');
			elementRef.reset();
			elementRef.updateValueAndValidity();
			return
		}
	}

	onCancel(data) {
		this.cancel.emit(data);
	}
}
